export default () => ({
    isLoading: false
});
